import { render, staticRenderFns } from "./AkStockRelationDataTable.vue?vue&type=template&id=0cb8750a&"
import script from "./AkStockRelationDataTable.vue?vue&type=script&lang=js&"
export * from "./AkStockRelationDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb8750a')) {
      api.createRecord('0cb8750a', component.options)
    } else {
      api.reload('0cb8750a', component.options)
    }
    module.hot.accept("./AkStockRelationDataTable.vue?vue&type=template&id=0cb8750a&", function () {
      api.rerender('0cb8750a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkStockRelationDataTable.vue"
export default component.exports